import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import { Router } from 'react-router-dom';
import cryptr from 'cryptr';
import { createBrowserHistory } from 'history';
import { UserAccessContext } from 'context/userAccess';
import { ACCESS_MATRIX } from 'global_config/constant-global';
import { getUserAccess } from 'utils/user';
import Header from './header';
import Content from './content';
import Sider from './sider';
import moment from 'moment';

import { fetchExtracReqByDate } from 'services/phlebo/specimenTracking';

import './layout.css';

const history = createBrowserHistory({ basename: process.env.PUBLIC_URL });

const initialAccessState = {
	view: false,
	create: false,
	update: false,
	print: false,
};

function MainLayout() {
	// const [count, setCount] = useState(0);
	const [userAccess, setUserAccess] = useState({
		dashboard: initialAccessState,
		createRequest: initialAccessState,
		editRequest: initialAccessState,
		viewRequest: initialAccessState,
		plhebo: initialAccessState,
		result: initialAccessState,
		patientDemographics: initialAccessState,
		settings: initialAccessState,
		checkIn: initialAccessState,
		dataAnalysis: initialAccessState,
	});

	// const [count,setCount] = useState(0);

	// useEffect(() => {
	//   // Update the document title using the browser API
	//   document.title = `You clicked ${count} times`;
	// });

	function defineUserAccess({ accessMatrix }) {
		const dashboard = accessMatrix.find(item => item.moduleID === 1);
		const createRequest = accessMatrix.find(item => item.moduleID === 2);
		const editRequest = accessMatrix.find(item => item.moduleID === 3);
		const viewRequest = accessMatrix.find(item => item.moduleID === 4);
		const plhebo = accessMatrix.find(item => item.moduleID === 5);
		const checkIn = accessMatrix.find(item => item.moduleID === 6);
		const result = accessMatrix.find(item => item.moduleID === 7);
		const patientDemographics = accessMatrix.find(item => item.moduleID === 8);
		const dataAnalysis = accessMatrix.find(item => item.moduleID === 10);
		const settings = accessMatrix.find(item => item.moduleID === 9);

		setUserAccess({
			dashboard: getUserAccess(dashboard),
			createRequest: getUserAccess(createRequest),
			editRequest: getUserAccess(editRequest),
			viewRequest: getUserAccess(viewRequest),
			plhebo: getUserAccess(plhebo),
			result: getUserAccess(result),
			patientDemographics: getUserAccess(patientDemographics),
			settings: getUserAccess(settings),
			checkIn: getUserAccess(checkIn),
			dataAnalysis: getUserAccess(dataAnalysis),
		});
	}

	useEffect(() => {
		const stringAccMatrix = sessionStorage.getItem(ACCESS_MATRIX);

		console.log('=>', stringAccMatrix);

		if (stringAccMatrix) {
			// const crypt = new cryptr(process.env.REACT_APP_CRYPTR_KEY);
			// const decryptedMatrix = crypt.decrypt(stringAccMatrix);
			const accessMatrix = JSON.parse(stringAccMatrix);

			console.log('=>', accessMatrix);

			defineUserAccess({ accessMatrix });
		}
	}, []);

	// async function getData(){
	//   const dateToday = moment().format('YYYYDDMM')
	//   console.log("🚀 ~ file: index.js:83 ~ getData ~ dateToday:", dateToday)
	//   try {
	//       const data = await fetchExtracReqByDate({ requestDate: dateToday.toString() });
	//       console.log("🚀 ~ file: index.js:86 ~ getData ~ data:", data)

	//       // setCount(data)
	//   } catch (error) {
	//     console.log(error)
	//   }
	// }

	// useEffect( ()=> {
	//     function fetchData() {
	//       getData();
	//     }
	//     fetchData();
	// }, []);

	return (
		<Router history={history}>
			<UserAccessContext.Provider value={{ userAccess, defineUserAccess }}>
				<Layout style={{ minHeight: '100vh' }}>
					<Header />
					<Layout>
						<Sider collapsed />
						<Content />
					</Layout>
				</Layout>
			</UserAccessContext.Provider>
		</Router>
	);
}

export default MainLayout;
